import React from "react";
import { Box, Chip, Typography } from "@mui/material";
import { RiAttachmentLine } from "@remixicon/react";
import { tokens } from "../../utils/figmaTokens";
import { KindTile, Line, Panel } from "./TicketParts";

// What was reported (D60; Report summary on 10829:93565): the kind's tile, the caption and the
// title, the source chip, the text as sent, and the foot line of what the ticket copied from the
// lesson. `card` is ticketDetail.reportCard; `pending` says the messages that hold a request's
// text are still loading, and `failed` that they could not be read.
const ReportCard = ({ card, tone, pending = false, failed = false }) => (
  <Panel>
    <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", flexWrap: "wrap", gap: "12px" }}>
      <Box sx={{ display: "flex", alignItems: "center", gap: "12px", minWidth: 0 }}>
        <KindTile tone={tone.tone} icon={tone.icon} size={40} />
        <Box sx={{ minWidth: 0, display: "flex", flexDirection: "column", gap: "2px" }}>
          <Typography variant="labelCaption" sx={{ color: tokens.text.secondary }}>
            {card.caption}
          </Typography>
          <Typography variant="titleCard" component="h2" sx={{ color: tokens.text.primary, overflowWrap: "anywhere" }}>
            {card.title}
          </Typography>
        </Box>
      </Box>
      <Chip label={card.chip} />
    </Box>
    <Line />
    {card.text ? (
      <Typography variant="bodySmallStrong" sx={{ color: tokens.text.primary, whiteSpace: "pre-wrap", overflowWrap: "anywhere" }}>
        {card.text}
      </Typography>
    ) : (
      <Typography variant="bodySmall" sx={{ color: tokens.text.tertiary }}>
        {pending ? "Loading…" : failed ? "Could not load the text of this ticket." : "No text was sent with this ticket."}
      </Typography>
    )}
    {card.foot && (
      <>
        <Line />
        <Box sx={{ display: "flex", alignItems: "center", gap: "8px", color: tokens.text.secondary }}>
          <RiAttachmentLine size={16} aria-hidden style={{ flexShrink: 0 }} />
          <Typography variant="labelMedium">{card.foot}</Typography>
        </Box>
      </>
    )}
  </Panel>
);

export default ReportCard;
